export default "__VITE_ASSET__Dg4Ne7sk__"